module.exports = __webpack_public_path__ + "97c4e8336154323b2d2c24683c95b24f.pdf";